import withDefaultLayout from '@/hoc/WithDefaultLayout';
import { useSearchParams } from 'react-router-dom';
import SankalpSheetDetails from './screens/sankalpSheetDetails';
import StoreListSankalp from './screens/storeListSankalp';




const ManageSankalpSheet = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const currentPage = searchParams.get("store_id")

    return currentPage ? <SankalpSheetDetails /> : <StoreListSankalp />
};

export default withDefaultLayout(ManageSankalpSheet);
